import { render, staticRenderFns } from "./setaddress.vue?vue&type=template&id=a49c820a&scoped=true&"
import script from "./setaddress.vue?vue&type=script&lang=js&"
export * from "./setaddress.vue?vue&type=script&lang=js&"
import style0 from "./setaddress.vue?vue&type=style&index=0&id=a49c820a&lang=scss&scoped=true&"
import style1 from "./setaddress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49c820a",
  null
  
)

export default component.exports